import { slicedToArray as _slicedToArray } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState, useEffect } from 'react';
import { LoadingHeading, Bullet } from './MegaForm.styles.js';
import Spinner from './Spinner.js';

var LoadingStep = function LoadingStep(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$loadingStepValue = _ref.loadingStepValues,
    loadingStepValues = _ref$loadingStepValue === void 0 ? {
      title: null,
      description: null
    } : _ref$loadingStepValue,
    _ref$loadingDelayPerI = _ref.loadingDelayPerItem,
    loadingDelayPerItem = _ref$loadingDelayPerI === void 0 ? 1000 : _ref$loadingDelayPerI;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];

  // Creates an array of the loadStepValues that we can map over below
  var values = Object.values(loadingStepValues);
  var totalLoadTime = (values.length + 1) * loadingDelayPerItem;
  useEffect(function () {
    // Sets a timeout to go to the final step of the form after all of the animations have finished.
    // totalLoadTime is the number of items we're going to animate, which is the loadingDelayPerItem of each item,
    // plus 1 extra to give the user time to read the final bullet. This creates a false sense that
    // we're processing something - the marketing team loves this
    var timeout = setTimeout(function () {
      setIsLoading(false);
    }, totalLoadTime);

    // runs on unmount so a state change doesn't occur after the component is unmounted
    // Cleanup function to clear the timeout
    return function () {
      return clearTimeout(timeout);
    };
  }, [totalLoadTime]);
  return /*#__PURE__*/React__default.createElement("div", null, isLoading && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Spinner, {
    className: "loading-step"
  }), /*#__PURE__*/React__default.createElement(LoadingHeading, {
    className: "heading",
    variant: "h4"
  }, "Processing Request"), values.map(function (_ref2, i) {
    var title = _ref2.title,
      description = _ref2.description;
    return /*#__PURE__*/React__default.createElement(Bullet, {
      className: "bullet",
      key: title,
      animationDelay: loadingDelayPerItem * (i + 1)
    }, /*#__PURE__*/React__default.createElement("strong", null, "\u2713 ", title, ": "), /*#__PURE__*/React__default.createElement("span", null, description));
  })), !isLoading && children);
};
var LoadingStep$1 = LoadingStep;

export { LoadingStep$1 as default };
//# sourceMappingURL=LoadingStep.js.map
